﻿import { Component, Inject } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { AuthenticationService } from "../../services/authenticationService"
import { Application } from "../application"


@Component({
    module: FIQAssist,
    selector: "logout",
    templateUrl: "views/goodbye.html",
    require: {
        application: "^application"
    }
})
class Logout {
    private application: Application;

    constructor(
        @Inject('$timeout') $timeout: angular.ITimeoutService,
        @Inject() authenticationService: AuthenticationService) {
        authenticationService.logout(5000);
    }

    $onInit() {
        this.application.forcedCustomer = ' ';
    }

    $onDestroy() {
        this.application.forcedCustomer = null;
    }
}